import { render, staticRenderFns } from "./InstanceEditKeycloak.vue?vue&type=template&id=1d1e26a7&"
import script from "./InstanceEditKeycloak.vue?vue&type=script&lang=js&"
export * from "./InstanceEditKeycloak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports